import { render, staticRenderFns } from "./VideoPlayerUI.vue?vue&type=template&id=0ef8de9f&scoped=true&"
import script from "./VideoPlayerUI.vue?vue&type=script&lang=js&"
export * from "./VideoPlayerUI.vue?vue&type=script&lang=js&"
import style0 from "./VideoPlayerUI.vue?vue&type=style&index=0&id=0ef8de9f&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef8de9f",
  null
  
)

export default component.exports